import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TerminosComponent } from './terminos/terminos';
import { PrivacidadComponent } from './privacidad/privacidad';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  readonly site = environment.siteConfig;
  constructor(private readonly dialog: MatDialog) {}
  goUbicacion() {
    window.open(this.site.contact.mapsUrl, '_blank', 'noopener,noreferrer');
  }
  goRedAMR() {
    window.open('https://redamr.com.ar/', '_blank');
  }
  goAsociacionMedica() {
    window.open('https://web.amr.org.ar/', '_blank');
  }
  goLaMutual() {
    window.open('https://www.mutualamr.org.ar/', '_blank');
  }
  goAliare() {
    window.open('https://www.sanatorioaliare.com/', '_blank');
  }
  goAMR() {
    window.open('https://gestion.amr.org.ar/', '_blank');
  }
  goAMPAR() {
    window.open('https://ampar.amr.org.ar/', '_blank');
  }
  goARMSalud() {
    window.open('https://web.amrsalud.com.ar/', '_blank');
  }
  goCedyca() {
    window.open('https://cedyca.amr.org.ar/', '_blank');
  }
  goEspanol() {
    window.open('https://he.amr.org.ar/', '_blank');
  }

  openTermsAndConditions() {
    this.dialog.open(TerminosComponent, {
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      autoFocus: false,
    });
  }

  openPrivacyPolicy() {
    this.dialog.open(PrivacidadComponent, {
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      autoFocus: false,
    });
  }
}
